var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9998 7.60078C3.9998 7.15895 4.35798 6.80078 4.7998 6.80078H19.1998C19.6416 6.80078 19.9998 7.15895 19.9998 7.60078V20.0008C19.9998 20.4426 19.6416 20.8008 19.1998 20.8008H4.79981C4.35798 20.8008 3.9998 20.4426 3.9998 20.0008V7.60078Z",
    fill: "#9DB2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7998 3.60078C2.7998 3.15895 3.15798 2.80078 3.5998 2.80078H20.3998C20.8416 2.80078 21.1998 3.15895 21.1998 3.60078V8.00078C21.1998 8.44261 20.8416 8.80078 20.3998 8.80078H3.5998C3.15798 8.80078 2.7998 8.44261 2.7998 8.00078V3.60078Z",
    fill: "#B6C6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19981 10.8008C9.19981 10.5799 9.37889 10.4008 9.59981 10.4008H14.3998C14.6207 10.4008 14.7998 10.5799 14.7998 10.8008V12.8008C14.7998 13.0217 14.6207 13.2008 14.3998 13.2008H9.59981C9.37889 13.2008 9.19981 13.0217 9.19981 12.8008V10.8008Z",
    fill: "#D0DBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeCollection);
export default __webpack_public_path__ + "static/media/tree-collection.01ad049c.svg";
export { ForwardRef as ReactComponent };